import { render, staticRenderFns } from "./Pay.vue?vue&type=template&id=bf6f1d78&scoped=true&"
import script from "./Pay.vue?vue&type=script&lang=js&"
export * from "./Pay.vue?vue&type=script&lang=js&"
import style0 from "./Pay.vue?vue&type=style&index=0&id=bf6f1d78&prod&lang=css&"
import style1 from "./Pay.vue?vue&type=style&index=1&id=bf6f1d78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6f1d78",
  null
  
)

export default component.exports